import classNames from "classnames"
import React from "react"

import Link from "@components/elements/Link"
import TextButton from "@components/elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getBackgroundColorClass } from "@utils/V2/color"

type Props = {
  logo: string
  badgeText: string
  image: string
  description: string
  link: string | YocoCom.YocoLink | undefined
}

const CaseStudyCard = ({
  logo,
  badgeText,
  image,
  description,
  link,
}: Props) => {
  return (
    <div>
      <div className="relative">
        <div
          className={classNames(
            "absolute bottom-10 left-8 z-10 rounded-[6px] bg-opacity-50 px-8 py-[5px]",
            getBackgroundColorClass(Color.Black)
          )}
        >
          <Typography
            text={badgeText}
            weight="medium"
            font="grotesk"
            color={Color.White}
            size="body-sm"
          />
        </div>
        <GatsbyStoryblokImage image={image} alt="" className="rounded-t-10" />
      </div>

      <div className="pr-20">
        <div className="my-[18px] flex h-[55px] items-center justify-between">
          <GatsbyStoryblokImage image={logo} alt="" />
          <Link link={link ?? ""} className="flex items-center gap-8">
            <TextButton
              text="Read story"
              weight="medium"
              textSize="body-md"
              style="icon"
              icon={<ArrowIcon />}
              color={Color.White}
            />
          </Link>
        </div>
        <Typography
          text={description}
          weight="book"
          font="grotesk"
          color={Color.White}
          size="body-md"
        />
      </div>
    </div>
  )
}

export default CaseStudyCard
